// extracted by mini-css-extract-plugin
export default {"login_singup_main_1":"LoginAndSignUp_login_singup_main_1__NkrOY","login_singup_main_2":"LoginAndSignUp_login_singup_main_2__yX1rP"};